<ng-content></ng-content>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/drop.down/item/drop.down.item.component.html